import { TARIFF_TYPES } from 'config/app-config';

import { TProduct } from 'api/models/TProduct';

export const useTariffType = (product: TProduct = {}) => {
  const { electricityTil, gasTil } = product;
  const tariff = electricityTil || gasTil;
  const tariffType = tariff?.tariffType;

  return {
    tariffType,
    isFixed: tariffType === TARIFF_TYPES.FIXED,
    isVariable: tariffType === TARIFF_TYPES.VARIABLE,
    isTracker: tariffType === TARIFF_TYPES.TRACKER
  };
};
